import React from 'react';
import {
  FooterBox,
  FooterBoxLink,
  FooterBoxSubtitle,
  FooterBoxTitle,
  FooterBoxWrapper,
  FooterContainer,
  FooterTitle
} from './styles';

export const HelpCenterFooter = () => {
  return (
    <FooterContainer>
      <FooterTitle>Fale conosco</FooterTitle>
      <FooterBoxWrapper>
        <FooterBox>
          <FooterBoxTitle>
            Entre em contato conosco através do telefone da central de
            atendimento.
          </FooterBoxTitle>
          <FooterBoxSubtitle>0800 722 3322</FooterBoxSubtitle>
        </FooterBox>
        <FooterBox>
          <FooterBoxTitle>
            Envie um e-mail através do endereço abaixo e receba uma resposta em
            até 48h.
          </FooterBoxTitle>
          <FooterBoxLink href="mailto:Suporte Gerdau mais<suportegerdaumais@gerdau.com.br>">
            suportegerdaumais@gerdau.com.br
          </FooterBoxLink>
        </FooterBox>
      </FooterBoxWrapper>
    </FooterContainer>
  );
};
